// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2nXzI","error":"Textarea_error__1jqWA","readonly":"Textarea_readonly__ZmG-a","disabled":"Textarea_disabled__9WjDv"};